import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import { Tooltip, message } from "antd";
import { paginate } from "../../../utlits/Paginate.js";
import Pagination from "../../Reuseable/Pagination";
import DataParser from "../../../utlits/Dataparser";
import IPAddressServices from "../../../Services/IPAddressService";
import secureLocalStorage from "react-secure-storage";
import SocketService from "../../../Services/SocketService";
import TableSkeleton from "../../Reuseable/TableSkeleton";

message.config({ zIndex: 1000000001 });

const IPAddress = () => {
  const [IPAddressList, setIPAddressList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(10);
  const [userPermissions, setuserPermissions] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [ipaddress, setIPAddress] = useState("");
  const [ipaddressEdit, setIPAddressEdit] = useState("");
  const [editID, setEditID] = useState("");
  const [itemToDelete, setItemToDelete] = useState(null);

  const companyId = DataParser.CompanyId();
  const navigate = useNavigate();

  const getData = (silent = false) => {
    if (!silent) setLoading(true);
    IPAddressServices.getIPAddress(companyId)
      .then((res) => {
        if (res.data === "Un-Athunticated request") {
          secureLocalStorage.removeItem("adminInfo");
          secureLocalStorage.removeItem("admins");
          navigate("/");
          return;
        }
        setIPAddressList(res.data.ipaddress || []);
      })
      .catch((err) => console.error("Error fetching ipaddress:", err))
      .finally(() => { if (!silent) setLoading(false); });
  };

  const handelPageChange = (e, page) => {
    e.preventDefault();
    setCurrentPage(page);
  };

  useEffect(() => {
    getData();
    setuserPermissions(DataParser.CompanyUserPermissions());
  }, []);

  useEffect(() => {
    SocketService.connect();
    const handleIPAddressUpdate = (data) => {
      if ((data.company_id && Number(data.company_id) === Number(companyId)) || data.action === "delete") {
        if (data.action === "update" && data.data) {
          setIPAddressList(prev => prev.map(item => Number(item.id) === Number(data.data.id) ? data.data : item));
        } else if (data.action === "delete" && data.id) {
          setIPAddressList(prev => prev.filter(item => Number(item.id) !== Number(data.id)));
        } else {
          getData(true);
        }
      }
    };
    SocketService.on("ipaddress_update", handleIPAddressUpdate);
    return () => SocketService.off("ipaddress_update", handleIPAddressUpdate);
  }, [companyId]);

  const handelSubmit = (e) => {
    e.preventDefault();
    if (!ipaddress || ipaddress.trim() === "") {
      setError("IP Address is required!");
      return;
    }
    IPAddressServices.createIPAddress({ ipaddress: ipaddress.trim(), company_id: companyId })
      .then((res) => {
        if (res.data === "Un-Athunticated request") {
          secureLocalStorage.removeItem("adminInfo");
          secureLocalStorage.removeItem("admins");
          navigate("/");
          return;
        }
        if (res.Good === true) {
          message.success("IP Address added successfully!");
          document.getElementById("IPAddressModalCreate").click();
          getData();
          setIPAddress("");
          setError("");
        } else {
          message.warning("Failed to add IP address. Please try again!");
        }
      })
      .catch((err) => {
        console.error("Error creating ipaddress:", err);
        message.error(err.response?.data?.message || "An unexpected error occurred.");
      });
  };

  const handleOpenUpadte = (e, item) => {
    e.preventDefault();
    setIPAddressEdit(item.ipaddress);
    setEditID(item.id);
    setError("");
  };

  const handelEditSubmit = (e) => {
    e.preventDefault();
    if (!ipaddressEdit || ipaddressEdit.trim() === "") {
      setError("IP Address is required!");
      return;
    }
    IPAddressServices.editIPAddress(editID, { ipaddress: ipaddressEdit.trim() })
      .then((res) => {
        if (res.data === "Un-Athunticated request") {
          secureLocalStorage.removeItem("adminInfo");
          secureLocalStorage.removeItem("admins");
          navigate("/");
          return;
        }
        if (res.Good === true) {
          message.success("IP Address updated successfully!");
          document.getElementById("IPAddressModalEdit").click();
          getData();
          setError("");
        } else {
          message.warning("Failed to update IP address. Please try again!");
        }
      })
      .catch((err) => {
        console.error("Error updating ip address:", err);
        message.error(err.response?.data?.message || "An unexpected error occurred.");
      });
  };

  const handelDelete = (e, item) => {
    e.preventDefault();
    setItemToDelete(item);
    document.getElementById("openDeleteIPModal").click();
  };

  const confirmDelete = async () => {
    if (!itemToDelete) return;
    setIPAddressList(prev => prev.filter(el => el.id !== itemToDelete.id));
    document.getElementById("closeIPDeleteModal").click();
    try {
      const res = await IPAddressServices.deleteIPAddress(itemToDelete.id, companyId);
      if (res.data === "Un-Athunticated request") {
        secureLocalStorage.removeItem("adminInfo");
        secureLocalStorage.removeItem("admins");
        navigate("/");
        return;
      }
      message.success("IP Address deleted successfully!");
      getData();
    } catch (err) {
      console.error("Delete error:", err);
      message.error("Failed to delete IP address. Please try again!");
      getData();
    }
    setItemToDelete(null);
  };

  const handleStatusToggle = async (item, index, newStatus) => {
    try {
      const res = await IPAddressServices.editIPAddress(item.id, { ipaddress: item.ipaddress, status: newStatus });
      if (res.data === "Un-Athunticated request") {
        secureLocalStorage.removeItem("adminInfo");
        secureLocalStorage.removeItem("admins");
        navigate("/");
        return;
      }
      if (res.Good) {
        message.success(`IP Address status updated to ${newStatus === 1 ? "Active" : "Inactive"}`);
        const updatedList = [...IPAddressList];
        updatedList[index].status = newStatus;
        setIPAddressList(updatedList);
      } else {
        message.error("Failed to update status.");
      }
    } catch (err) {
      console.error("Update status error:", err);
      message.error("An error occurred while updating the status.");
    }
  };

  const PaginatedData = paginate(IPAddressList, currentPage, pageSize);

  return (
    <>
      <Helmet>
        <title>IP Address - Planit</title>
      </Helmet>
      <div className="main-content">
        <div className="page-content Pagebody" style={{ backgroundColor: "#fff", minHeight: "100vh" }}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 px-0">
                <div className="d-flex align-items-end justify-content-end" style={{ padding: "0 0 12px 0" }}>
                  <div className="d-flex flex-column align-items-end" style={{ gap: "6px" }}>
                    <ol className="breadcrumb mb-0">
                      <li className="breadcrumb-item">
                        <Link to={`/${DataParser.CompanyIdentifierRole()}/employee-attendance`}>Home</Link>
                      </li>
                      <li className="breadcrumb-item active">
                        <Link to={`/${DataParser.CompanyIdentifierRole()}/settings`}>Settings</Link>
                      </li>
                      <li className="breadcrumb-item active">IP Address</li>
                    </ol>
                    {userPermissions.indexOf("ipaddress-create") !== -1 ? (
                      <button
                        type="button"
                        className="btn btn-primary waves-effect waves-light"
                        style={{ borderRadius: "5px" }}
                        data-bs-toggle="modal"
                        data-bs-target="#createIPAddressModal"
                      >
                        Add IP Address
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-primary waves-effect waves-light"
                        disabled
                        style={{ opacity: 0.6, cursor: "not-allowed", borderRadius: "5px" }}
                      >
                        Add IP Address
                      </button>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-lg-12 px-0">
                <div className="card" style={{ backgroundColor: "#fff", boxShadow: "none", borderRadius: 0, border: "none" }}>
                  <div className="card-body p-0">
                    <div className="table-responsive listing-table-wrapper">
                      <table className="table mb-0 custom-table listing-table">
                        <thead>
                          <tr className="tableHeaderbg">
                            <th>Sr#</th>
                            <th>IP Address</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {isLoading ? (
                            <TableSkeleton cols={4} rows={6} />
                          ) : PaginatedData.length > 0 ? (
                            PaginatedData.map((item, index) => (
                              <tr key={item.id}>
                                <td>{index + 1}</td>
                                <td>{item.ipaddress}</td>
                                <td>
                                  {userPermissions.indexOf("ipaddress-edit") !== -1 ? (
                                    <Link to="#" onClick={(e) => { e.preventDefault(); handleStatusToggle(item, index, item.status === 1 ? 0 : 1); }}>
                                      {item.status === 1 ? (
                                        <span className="btn btn-success waves-effect waves-light btn-sm">Active</span>
                                      ) : (
                                        <span className="btn btn-danger waves-effect waves-light btn-sm">Inactive</span>
                                      )}
                                    </Link>
                                  ) : (
                                    item.status === 1 ? (
                                      <span className="btn btn-success waves-effect waves-light btn-sm" style={{ cursor: "default", opacity: 0.7 }}>Active</span>
                                    ) : (
                                      <span className="btn btn-danger waves-effect waves-light btn-sm" style={{ cursor: "default", opacity: 0.7 }}>Inactive</span>
                                    )
                                  )}
                                </td>
                                <td>
                                  {userPermissions.indexOf("ipaddress-delete") !== -1 ? (
                                    <Link to="#" className="cursor-pointer iconscolor" onClick={(e) => handelDelete(e, item)}>
                                      <Tooltip title="Delete">
                                        <i className="uil-trash iconscolor" />
                                      </Tooltip>
                                    </Link>
                                  ) : (
                                    <span className="uil-trash iconscolor text-muted" style={{ cursor: "not-allowed", opacity: 0.5 }} />
                                  )}
                                  {userPermissions.indexOf("ipaddress-edit") !== -1 ? (
                                    <Link
                                      to="#"
                                      className="cursor-pointer iconscolor"
                                      onClick={(e) => handleOpenUpadte(e, item)}
                                      data-bs-toggle="modal"
                                      data-bs-target="#editIPAddressModal"
                                    >
                                      <Tooltip title="Edit">
                                        <i className="uil-pen iconscolor" />
                                      </Tooltip>
                                    </Link>
                                  ) : (
                                    <span className="uil-pen iconscolor text-muted" style={{ cursor: "not-allowed", opacity: 0.5 }} />
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="4" className="text-center">
                                No IP addresses found. Click 'Add IP Address' to add one.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>

                      {IPAddressList.length > pageSize && (
                        <div className="d-flex justify-content-center mt-4">
                          <Pagination
                            itemCount={IPAddressList.length}
                            currentPage={currentPage}
                            pageSize={pageSize}
                            onPageChange={handelPageChange}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Hidden trigger for delete modal */}
        <div id="openDeleteIPModal" data-bs-toggle="modal" data-bs-target="#deleteIPAddressModal" style={{ display: "none" }} />

        {/* Delete Confirmation Modal */}
        <div id="deleteIPAddressModal" className="modal fade" tabIndex={-1} role="dialog" aria-hidden="true" data-bs-keyboard="false">
          <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
            <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
              <div className="modal-header border-0 pb-1">
                <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Delete IP Address</h5>
                <button type="button" className="btn-close" id="closeIPDeleteModal" data-bs-dismiss="modal" aria-label="Close" onClick={() => setItemToDelete(null)} />
              </div>
              <div className="modal-body pt-2 pb-2">
                <p style={{ fontSize: "14px", color: "#1D1D1D", marginBottom: "6px" }}>Are you sure you want to delete this IP address?</p>
                <p style={{ fontSize: "13px", color: "#ff4d4f", marginBottom: 0 }}>
                  <i className="uil uil-exclamation-triangle me-1" />
                  This action cannot be undone.
                </p>
              </div>
              <div className="modal-footer border-0 pt-1">
                <button type="button" className="btn btn-danger waves-effect waves-light" onClick={confirmDelete} style={{ borderRadius: "5px", fontSize: "13px" }}>
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Create Modal */}
        <div id="createIPAddressModal" className="modal fade" tabIndex={-1} role="dialog" aria-hidden="true" data-bs-keyboard="false">
          <form onSubmit={handelSubmit}>
            <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
              <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
                <div className="modal-header border-0 pb-1">
                  <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Add IP Address</h5>
                  <button
                    type="button"
                    className="btn-close"
                    id="IPAddressModalCreate"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => { setIPAddress(""); setError(""); }}
                  />
                </div>
                <div className="modal-body pt-2 pb-2">
                  <div className="float-input-wrap">
                    <input
                      type="text"
                      className={error ? "is-invalid" : ""}
                      placeholder=" "
                      value={ipaddress}
                      onChange={(e) => { setIPAddress(e.target.value); if (e.target.value.trim() !== "") setError(""); }}
                    />
                    <label>IP Address*</label>
                  </div>
                  {error && <small className="text-danger mt-1 d-block">{error}</small>}
                </div>
                <div className="modal-footer border-0 pt-1">
                  <button
                    type="button"
                    className="btn btn-primary waves-effect waves-light"
                    style={{ borderRadius: "5px", fontSize: "13px" }}
                    onClick={handelSubmit}
                  >
                    + Add IP Address
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>

        {/* Edit Modal */}
        <div id="editIPAddressModal" className="modal fade" tabIndex={-1} role="dialog" aria-hidden="true" data-bs-keyboard="false">
          <form onSubmit={handelEditSubmit}>
            <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
              <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
                <div className="modal-header border-0 pb-1">
                  <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Edit IP Address</h5>
                  <button
                    type="button"
                    className="btn-close"
                    id="IPAddressModalEdit"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => setError("")}
                  />
                </div>
                <div className="modal-body pt-2 pb-2">
                  <div className="float-input-wrap">
                    <input
                      type="text"
                      className={error ? "is-invalid" : ""}
                      placeholder=" "
                      value={ipaddressEdit}
                      onChange={(e) => { setIPAddressEdit(e.target.value); if (e.target.value.trim() !== "") setError(""); }}
                    />
                    <label>IP Address*</label>
                  </div>
                  {error && <small className="text-danger mt-1 d-block">{error}</small>}
                </div>
                <div className="modal-footer border-0 pt-1">
                  <button
                    type="button"
                    className="btn btn-primary waves-effect waves-light"
                    style={{ borderRadius: "5px", fontSize: "13px" }}
                    onClick={handelEditSubmit}
                  >
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default IPAddress;
